// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/stylesheet/_payslider.scss
 ** module id = 450
 ** module chunks = 1
 **/